"use strict";
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _awaitAsyncGenerator = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var query_partition_1 = require("./query-partition");

var util_1 = require("./util");

var logger_1 = require("./logger");

var reference_1 = require("./reference");

var path_1 = require("./path");

var validate_1 = require("./validate");

var types_1 = require("./types");

var order_1 = require("./order");
/**
 * A `CollectionGroup` refers to all documents that are contained in a
 * collection or subcollection with a specific collection ID.
 *
 * @class CollectionGroup
 */


var CollectionGroup =
/*#__PURE__*/
function (_reference_1$Query) {
  _inherits(CollectionGroup, _reference_1$Query);

  /** @hideconstructor */
  function CollectionGroup(firestore, collectionId, converter) {
    _classCallCheck(this, CollectionGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(CollectionGroup).call(this, firestore, reference_1.QueryOptions.forCollectionGroupQuery(collectionId, converter)));
  }
  /**
   * Partitions a query by returning partition cursors that can be used to run
   * the query in parallel. The returned cursors are split points that can be
   * used as starting and end points for individual query invocations.
   *
   * @example
   * const query = firestore.collectionGroup('collectionId');
   * for await (const partition of query.getPartitions(42)) {
   *   const partitionedQuery = partition.toQuery();
   *   const querySnapshot = await partitionedQuery.get();
   *   console.log(`Partition contained ${querySnapshot.length} documents`);
   * }
   *
   * @param {number} desiredPartitionCount The desired maximum number of
   * partition points. The number must be strictly positive. The actual number
   * of partitions returned may be fewer.
   * @return {AsyncIterable<QueryPartition>} An AsyncIterable of
   * `QueryPartition`s.
   */


  _createClass(CollectionGroup, [{
    key: "getPartitions",
    value: function getPartitions(desiredPartitionCount) {
      var _this = this;

      return _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _a, tag, partitions, queryWithDefaultOrder, request, stream, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, currentCursor, i;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validate_1.validateInteger('desiredPartitionCount', desiredPartitionCount, {
                  minValue: 1
                });
                tag = util_1.requestTag();
                _context.next = 4;
                return _awaitAsyncGenerator(_this.firestore.initializeIfNeeded(tag));

              case 4:
                partitions = [];

                if (!(desiredPartitionCount > 1)) {
                  _context.next = 46;
                  break;
                }

                // Partition queries require explicit ordering by __name__.
                queryWithDefaultOrder = _this.orderBy(path_1.FieldPath.documentId());
                request = queryWithDefaultOrder.toProto(); // Since we are always returning an extra partition (with an empty endBefore
                // cursor), we reduce the desired partition count by one.

                request.partitionCount = desiredPartitionCount - 1;
                _context.next = 11;
                return _awaitAsyncGenerator(_this.firestore.requestStream('partitionQueryStream', request, tag));

              case 11:
                stream = _context.sent;
                stream.resume();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 15;
                _iterator = _asyncIterator(stream);

              case 17:
                _context.next = 19;
                return _awaitAsyncGenerator(_iterator.next());

              case 19:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 23;
                return _awaitAsyncGenerator(_step.value);

              case 23:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 30;
                  break;
                }

                currentCursor = _value;
                partitions.push((_a = currentCursor.values) !== null && _a !== void 0 ? _a : []);

              case 27:
                _iteratorNormalCompletion = true;
                _context.next = 17;
                break;

              case 30:
                _context.next = 36;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](15);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 36:
                _context.prev = 36;
                _context.prev = 37;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 41;
                  break;
                }

                _context.next = 41;
                return _awaitAsyncGenerator(_iterator.return());

              case 41:
                _context.prev = 41;

                if (!_didIteratorError) {
                  _context.next = 44;
                  break;
                }

                throw _iteratorError;

              case 44:
                return _context.finish(41);

              case 45:
                return _context.finish(36);

              case 46:
                logger_1.logger('Firestore.getPartitions', tag, 'Received %d partitions', partitions.length); // Sort the partitions as they may not be ordered if responses are paged.

                partitions.sort(function (l, r) {
                  return order_1.compareArrays(l, r);
                });
                i = 0;

              case 49:
                if (!(i < partitions.length)) {
                  _context.next = 55;
                  break;
                }

                _context.next = 52;
                return new query_partition_1.QueryPartition(_this._firestore, _this._queryOptions.collectionId, _this._queryOptions.converter, i > 0 ? partitions[i - 1] : undefined, partitions[i]);

              case 52:
                ++i;
                _context.next = 49;
                break;

              case 55:
                _context.next = 57;
                return new query_partition_1.QueryPartition(_this._firestore, _this._queryOptions.collectionId, _this._queryOptions.converter, partitions.pop(), undefined);

              case 57:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[15, 32, 36, 46], [37,, 41, 45]]);
      }))();
    }
  }, {
    key: "withConverter",
    value: function withConverter(converter) {
      return new CollectionGroup(this.firestore, this._queryOptions.collectionId, converter !== null && converter !== void 0 ? converter : types_1.defaultConverter());
    }
  }]);

  return CollectionGroup;
}(reference_1.Query);

exports.CollectionGroup = CollectionGroup;